import { render } from "./ManualReview.vue?vue&type=template&id=31fcea42&scoped=true"
import script from "./ManualReview.vue?vue&type=script&lang=js"
export * from "./ManualReview.vue?vue&type=script&lang=js"

import "./ManualReview.vue?vue&type=style&index=0&id=31fcea42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31fcea42"]])

export default __exports__